// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { type FC, type FocusEventHandler, type KeyboardEventHandler } from 'react';
import { type parameterKey } from '../hooks/use-simulation';
import InputNumber from 'rc-input-number';
import { classNames } from '@shared/ui-kit/utils/classnames';

export interface InputParameterProps {
  value: number;
  className?: string;
  onChange: (key: parameterKey, value: number) => void;
  inputKey: parameterKey;
  onBlur?: FocusEventHandler<HTMLInputElement>;
  onKeyPress?: KeyboardEventHandler<HTMLInputElement>;
  max: number;
  step?: number;
  precision?: number;
  symbol?: string;
  min?: number;
}

export const InputParameter: FC<InputParameterProps> = ({
  value,
  className = '',
  onChange,
  inputKey,
  onBlur,
  onKeyPress,
  max,
  step = 0.5,
  precision = 1,
  symbol = 'false',
  min = 0,
}) => {
  return (
    <InputNumber
      className={classNames(className, 'rc-input-number-input')}
      data-testid="simulation-parameter"
      value={value}
      min={min}
      max={max}
      step={step}
      precision={precision}
      formatter={value => `${value}${symbol}`}
      parser={value => value!.replace('%', '') as never}
      onChange={value => onChange(inputKey, value as number)}
      onBlur={onBlur}
      onKeyDown={onKeyPress}
      controls={false}
    />
  );
};
